import { Vue, newVue } from '@/config/vue'

const init = () => {
  const Navigation = Vue.component('navigation', () =>
    import(/* webpackChunkName: "navigation" */ './Navigation.vue')
  )
  newVue({
    render: h => h(Navigation),
    mount: 'header',
    stores: ['checkout', 'recommendation'],
  })
}
window.On.NavigationVueInit = init

On.VueInit({
  init({ isCheckout, isSpa }) {
    if (!isCheckout && !isSpa) init()
  },
})
